import { useState } from "react";
import DeliveriesForm from "./DeliveriesForm";
import PaymentDetailForm from "./payment";
import SuccessForm from "./SuccessForm";

export default function Home() {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <div className="flex justify-center items-center h-screen">
        {step === 1 && (
          <DeliveriesForm
            data={data}
            onChange={handleChange}
            onNext={(v) => setStep((prev) => prev + 1)}
          />
        )}
        {step === 2 && (
          <PaymentDetailForm
            data={data}
            onChange={handleChange}
            onPrevious={() => setStep((prev) => prev - 1)}
            onNext={(v) => setStep((prev) => prev + 1)}
          />
        )}
        {step === 3 && (
          <SuccessForm
            data={data}
            onChange={handleChange}
            onPrevious={() => setStep((prev) => prev - 1)}
          />
        )}
      </div>
    </>
  );
}
